interface RedirectUrlProps {
  url: string;
}

export default function RedirectUrl(props: RedirectUrlProps) {
  window.location.replace(props.url);

  return <div />;
}
